import CatalogIcon from '@/projects/mti/components/TheHeader/icons/CatalogIcon.vue';
import FaqIcon from '@/projects/mti/components/TheHeader/icons/FaqIcon.vue';
import InviteIcon from '@/projects/mti/components/TheHeader/icons/InviteIcon.vue';
import OrdersIcon from '@/projects/mti/components/TheHeader/icons/OrdersIcon.vue';
import ProfileIcon from '@/projects/mti/components/TheHeader/icons/ProfileIcon.vue';
import RulesIcon from '@/projects/mti/components/TheHeader/icons/RulesIcon.vue';
import SupportIcon from '@/projects/mti/components/TheHeader/icons/SupportIcon.vue';

export const navbarItems = [
  {
    title: 'header.profile',
    isAllowWithoutUserCard: true,
    icon: ProfileIcon,
    path: '/',
  },
  {
    title: 'header.invite',
    isAllowWithoutUserCard: false,
    icon: InviteIcon,
    path: '/invites',
  },
  {
    title: 'header.catalog',
    isAllowWithoutUserCard: false,
    icon: CatalogIcon,
    path: '/catalog',
  },
  {
    title: 'header.rules',
    isAllowWithoutUserCard: true,
    icon: RulesIcon,
    path: '/rules',
  },
  {
    title: 'header.orders',
    isAllowWithoutUserCard: false,
    icon: OrdersIcon,
    path: '/orders',
  },
  {
    title: 'header.faq',
    isAllowWithoutUserCard: true,
    icon: FaqIcon,
    path: '/faq',
  },
  {
    title: 'header.support',
    isAllowWithoutUserCard: true,
    icon: SupportIcon,
    path: '/support',
  },
];
